import { render, staticRenderFns } from "./riskNohlDialog.vue?vue&type=template&id=82966410"
import script from "./riskNohlDialog.vue?vue&type=script&lang=js"
export * from "./riskNohlDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports